export const CUSTOM_SKILL_REPORT_LIST_KEY = 'custom_skill';
const CUSTOM_SKILL_LIST_PREFIX = 'custom_skill_k';

export const combineCustomSkillValues = (
  entities: { type: string; values: string[]; id?: string }[]
) => {
  const customSkillValues: string[] = [];
  let customSkillId: string | undefined;

  entities.forEach((entity) => {
    if (entity.type.startsWith(CUSTOM_SKILL_LIST_PREFIX)) {
      if (!customSkillId && entity.id) {
        customSkillId = entity.id;
      }
      const kValue = entity.type.replace(CUSTOM_SKILL_LIST_PREFIX, '');
      entity.values.forEach((value) => {
        customSkillValues.push(`k${kValue}_${value}`);
      });
    }
  });
  return (() => {
    if (customSkillValues.length > 0) {
      return [
        ...entities,
        {
          type: CUSTOM_SKILL_REPORT_LIST_KEY,
          values: customSkillValues,
          id: customSkillId,
        },
      ];
    }
    return entities;
  })().filter((entity) => !entity.type.startsWith(CUSTOM_SKILL_LIST_PREFIX));
};
